/**
 * 获取引导页配置
 * @param {object} param
 * @param {string} param.gpid
 * @param {string} [param.mode]
 */
const getGuidePageConfig = {
    url: '/beyonder/api/v1/guide-pages/{gpid}',
    method: 'get'
};

/** 查询用户的专属fellow信息 https://apidoc.nioint.com/project/11730/interface/api/1391297 */
const fellow = {
    url: '/proxy/seige/v1/in/user/{user_id}/fellow',
    method: 'get',
    serverHost: '/dino'
};

// 你可能觉得类似的这些复制粘贴很傻逼
// 嗯 我也觉得
/** decode uniqueKey */
const decodeUniqueKey = {
    url: '/tools/v1/unique-key/decode',
    method: 'get',
    requstTypeJson: true,
    serverHost: '/dino'
};

export default {
    getGuidePageConfig,
    fellow,
    decodeUniqueKey
};



// WEBPACK FOOTER //
// ./src/service/marketing/guide.js